import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "store";
import { log, LogLevel } from "utils/LogUtil";

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading, user } = useSelector((state: RootState) => state.user);
  const location = useLocation();

  // 디버깅: 사용자 정보 출력
  useEffect(() => {
    log(LogLevel.VERBOSE, "AdminRoute - 현재 사용자 정보:", user);
    log(LogLevel.VERBOSE, "AdminRoute - 인증 상태:", isAuthenticated);
    log(LogLevel.VERBOSE, "AdminRoute - roles:", user?.roles);
  }, [user, isAuthenticated]);

  // 로딩 중인 경우 로딩 표시
  if (isLoading) {
    return <div>로딩 중...</div>;
  }

  // 인증되지 않은 경우 로그인 페이지로 리디렉션
  if (!isAuthenticated) {
    // state를 통해 현재 경로를 전달
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 인증은 되었지만 Admin 권한이 없는 경우
  // user가 있고, roles 배열이 있고, 그 안에 'admin'이 포함되어 있는지 확인
  if (!user || !user.roles || !Array.isArray(user.roles) || !user.roles.includes("admin")) {
    log(LogLevel.WARNING, "AdminRoute - Admin 권한 없음:", user);
    // 권한 없음 페이지 또는 홈으로 리디렉션
    return <Navigate to="/unauthorized" replace />;
  }

  // Admin 권한이 있는 경우 자식 컴포넌트 렌더링
  return <>{children}</>;
};

export default AdminRoute;
